import * as React from "react";
import { Field, Input, mergeClasses } from "@fluentui/react-components";

const CustomFieldsInput = ({
  label,
  validationMessage,
  validationMessageIcon = "",
  value = "",
  size = "large",
  inputType = "text",
  placeholder,
  name,
  className,
  inputClassName,
  inputId,
  inputDefaultValue,
  validation,
  noRequired,
  disabled,
  contentAfter,
  contentBefore,
  maxLength,
  onKeyDown,
  onFocus,
  onChange,
}) => {
  return (
    <Field
      label={label}
      validationMessage={validationMessage}
      className={mergeClasses("custom-label", className)}
      validationMessageIcon={validationMessageIcon}
      size={size}
      required={noRequired ? undefined : true}
    >
      <Input
        id={inputId}
        className={inputClassName}
        type={inputType}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        name={name}
        disabled={disabled}
        defaultValue={inputDefaultValue}
        maxLength={maxLength}
        placeholder={placeholder}
        contentBefore={contentBefore}
        contentAfter={contentAfter}
        {...validation}
        value={value}
        onChange={onChange}
      />
    </Field>
  );
};

export default CustomFieldsInput;
